<template>
  <div id="import_container" class="dropdown">

    <v-dialog
      v-model="loadingDialog.visible"
      :persistent="true"
      maxWidth="90%"
      width="450"
      :style="`z-index: ${this.core.confirmationIndex};position: fixed;`"
    >
      <v-card>
        <v-toolbar class="dialog_toolbar" dark color="primary"
          >{{ $t("common.loadingDialog.title") }}
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-title>
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-progress-circular
                  :size="90"
                  :width="15"
                  :rotate="360"
                  color="primary"
                  :value="
                    Math.floor(
                      (loadingDialog.completedTasks / loadingDialog.tasks) * 100
                    )
                  "
                  >{{
                    Math.floor(
                      (loadingDialog.completedTasks / loadingDialog.tasks) * 100
                    ) + "%"
                  }}</v-progress-circular
                ></v-col
              >
              <v-col cols="8" class="h6">
                <span>{{ $t("common.loadingDialog.totalCases") }}:</span>
                {{ loadingDialog.tasks }}<br /><br />
                {{ $t("common.loadingDialog.successMatches") }}:
                {{ loadingDialog.successMatchTasks }}<br /><br />
                <!-- <template v-if="loadingDialog.connectFailedTasks > 0">
                  <span class="red--text"
                    >{{
                      $t("common.loadingDialog.connectFailedTasksMessage")
                    }}:</span
                  >&nbsp;
                  <span class="red--text"
                    >{{ loadingDialog.connectFailedTasks }}<br /><br
                  /></span>
                </template> -->
              </v-col>
            </v-row>
          </v-container>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="enableRunInBackground"
            @click="loadingDialog.visible = false"
            >{{
              loadingDialog.completedTasks == loadingDialog.tasks
                ? $t("common.ok")
                : $t("common.loadingDialog.runInBackground")
            }}</v-btn
          >
          <v-btn
            v-else
            @click="
              loadingDialog.abortAutoMatch = true;
              loadingDialog.visible = false;
            "
            >{{
              loadingDialog.completedTasks == loadingDialog.tasks
                ? $t("common.ok")
                : $t("common.loadingDialog.abort")
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      id="import_modal"
      ref="import_modal"
      v-model="import_modal"
      scrollable
      maxWidth="90%"
      width="700"
      :persistent="true"
      :style="`z-index: ${this.core.confirmationIndex - 1};position: fixed;`"
    >
      <v-card>
        <v-toolbar class="dialog_toolbar" dark color="primary">
          {{ $t("common.import") }}<v-spacer></v-spacer>
          <v-btn
            icon
            dark
            large
            @click.stop="core.tour2.runImportSteps()"
            :title="$t('common.helpTitleTips')"
            ><v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn icon @click="import_modal = false"
            ><v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row class="my-1">
              <!-- formats -->
              <v-col
                cols="3"
                class="import_modal_label"
                style="color: rgba(0, 0, 0, 0.87)"
                ><label for="format"
                  >{{ $t("common.importDialog.format") }}:</label
                ></v-col
              >
              <v-col cols="9">
                <div ref="tour_format" class="import_format">
                  <v-btn
                    :class="
                      'import_modal_button' +
                      (current_format == format ? ' success' : '')
                    "
                    :key="format"
                    v-for="format in formats"
                    @click="updataCurrentFormat(format)"
                  >
                    {{ format }}
                  </v-btn>
                </div>
              </v-col>

              <template v-if="current_format == 'CSV'">
                <v-col cols="3"></v-col>
                <v-col cols="9">
                  <a
                    v-if="core.locate == GLOBAL.LANG.EN"
                    href="./src/CSV sample_ENG.csv"
                    color="red"
                    target="_blank"
                    ><u><i>CSV Sample File</i></u></a
                  >
                  <a
                    v-else
                    href="./src/CSV sample_CHI.csv"
                    target="_blank"
                    color="red"
                    ><u><i>CSV 檔案樣本</i></u></a
                  >
                </v-col>
              </template>

              <v-col
                cols="3"
                class="import_modal_label"
                style="color: rgba(0, 0, 0, 0.87)"
              >
                <label for="file"
                  >{{ $t("common.importDialog.file") }}:</label
                ></v-col
              >
              <v-col cols="9">
                <b-form-file
                  ref="tour_file"
                  accept=".txt, .csv, .geojson, .json, .xml, .kml, .gml"
                  :browse-text="$t('common.importDialog.browser')"
                  v-model="file"
                  :placeholder="
                    $t('common.importDialog.fileChooseOrDropMessage')
                  "
                  :drop-placeholder="
                    $t('common.importDialog.fileDropFileMessage')
                  "
                ></b-form-file>
                <b-form-invalid-feedback>{{
                  fileErrorMessage
                }}</b-form-invalid-feedback>
              </v-col>

              <template v-if="file">
                <!-- selected file -->
                <v-col
                  cols="3"
                  class="import_modal_label"
                  style="color: rgba(0, 0, 0, 0.87)"
                >
                  <label for="selectedFile"
                    >{{ $t("common.importDialog.selectedFile") }}:</label
                  >
                </v-col>
                <v-col
                  cols="9"
                  class="import_modal_selected_file"
                  style="color: rgba(0, 0, 0, 0.87)"
                  >{{ file.name }}</v-col
                >
              </template>

              <!-- input options -->
              <template v-if="file && verifyFileDataErrorResult.result">
                <v-row
                  class="import_modal_option_row"
                  style="margin-bottom: 3px"
                >
                  <v-col
                    cols="3"
                    class="import_modal_label"
                    style="color: rgba(0, 0, 0, 0.87)"
                    ><label for="option"
                      >{{ $t("common.importDialog.inputOption") }}:</label
                    ></v-col
                  >
                  <v-col cols="9">
                    <v-btn
                      :class="
                        'import_modal_button' +
                        (current_option == option ? ' success' : '')
                      "
                      :key="option"
                      v-for="option in options"
                      @click="current_option = option"
                      >{{ $t("common.importDialog." + option) }}</v-btn
                    >
                  </v-col>
                </v-row>
                <v-card
                  v-if="selectableHeaders.length > 0 && current_format == 'CSV'"
                  style="
                    width: 100%;
                    padding-top: 10px !important;
                    padding-bottom: 25px !important;
                  "
                >
                  <v-row class="import_modal_option_row">
                    <v-col cols="12" class="import_modal_label">
                      <label for="option">
                        {{ $t("common.importDialog.option") }}:</label
                      >
                    </v-col>
                  </v-row>
                  <!-- latitude & longitude -->
                  <v-sheet
                    color="grey lighten-3"
                    style="margin: 5px 15px; padding-bottom: 20px"
                  >
                    <v-row class="import_modal_option_row">
                      <v-col cols="12" class="import_modal_label" text-center>
                        <v-radio-group v-model="enableAutoMatchSearch" row>
                          <v-radio
                            :label="
                              $t(
                                'common.importDialog.batchLocationSearchManual'
                              )
                            "
                            :value="false"
                          ></v-radio>
                          <v-radio
                            :label="
                              $t('common.importDialog.batchLocationSearch')
                            "
                            :value="true"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-col
                      v-if="enableAutoMatchSearch"
                      cols="12"
                      class="import_modal_label"
                      id="csvAutoMatchOption"
                      style="padding-top: 0; padding-bottom: 0"
                    >
                      <v-radio-group
                        v-model="enableAutoMatchSearch_Location"
                        row
                      >
                        {{
                          $t(
                            "common.importDialog.batchLocationSearchManualStart"
                          )
                        }}
                        <v-radio
                          :label="
                            $t(
                              'common.importDialog.batchLocationSearchManualCoord'
                            )
                          "
                          :value="false"
                        ></v-radio>
                        <v-radio
                          ref="tour_step1"
                          :label="
                            $t(
                              'common.importDialog.batchLocationSearchManualAddress'
                            )
                          "
                          :value="true"
                        ></v-radio>

                        <v-btn
                          icon
                          small
                          :title="$t('common.helpTitleTips')"
                          @click.stop="core.tour2.runCSVAutoMatchTour()"
                        >
                          <v-icon>mdi-help-circle</v-icon>
                        </v-btn>
                      </v-radio-group>

                      <!-- <v-switch
                            id="enableAutoMatchSearch_Location"
                            v-model="enableAutoMatchSearch_Location"
                            color="success"
                            :label="
                              $t('common.importDialog.batchLocationSearch')
                            "
                          ></v-switch> -->
                    </v-col>

                    <v-col cols="12" v-if="!enableAutoMatchSearch">
                      {{ $t("common.importDialog.manualGeotagMessage") }}
                    </v-col>

                    <template
                      v-if="
                        enableAutoMatchSearch && !enableAutoMatchSearch_Location
                      "
                    >
                      <v-row class="import_modal_option_row">
                        <v-col cols="3" class="import_modal_label"
                          ><label for="coordinateReferenceSystem"
                            >{{
                              $t(
                                "common.importDialog.coordinateReferenceSystem"
                              )
                            }}:</label
                          ></v-col
                        >
                        <v-col cols="9">
                          <v-btn
                            style="padding: 25px 3px; min-width: 200px"
                            :class="
                              'import_modal_button' +
                              (current_crs_option == crs_option
                                ? ' success'
                                : '')
                            "
                            :key="crs_option"
                            v-for="crs_option in crs_options"
                            @click="current_crs_option = crs_option"
                            v-html="
                              crs_option == GLOBAL.IMPORT.CRS_OPTIONS.WGS1984
                                ? $t('common.importDialog.crsWGS1984Display')
                                : $t('common.importDialog.crsHK1980Display')
                            "
                          >
                          </v-btn>
                        </v-col>
                      </v-row>

                      <v-row
                        class="import_modal_option_row"
                        v-if="current_crs_option"
                      >
                        <v-col cols="3" class="import_modal_label text-center"
                          ><label
                            for="latitude"
                            v-html="
                              current_crs_option ==
                              GLOBAL.IMPORT.CRS_OPTIONS.WGS1984
                                ? $t('common.loadingDialog.latitude')
                                : current_crs_option ==
                                  GLOBAL.IMPORT.CRS_OPTIONS.HK1980
                                ? $t('common.northing')
                                : ''
                            "
                          >
                          </label
                        ></v-col>
                        <v-col cols="9">
                          <!-- <v-btn
                              :class="
                                'import_modal_button' +
                                (current_latitude == null ? ' error' : '')
                              "
                              @click="current_latitude = null"
                              >{{ $t("common.none") }}</v-btn
                            > -->

                          <v-btn
                            :class="
                              'import_modal_button' +
                              (current_latitude == selectabledItem
                                ? ' success'
                                : '')
                            "
                            :key="selectabledItem"
                            v-for="selectabledItem in selectableHeaders"
                            @click="current_latitude = selectabledItem"
                            >{{ selectabledItem }}
                          </v-btn>
                        </v-col>
                      </v-row>

                      <v-row
                        class="import_modal_option_row"
                        v-if="current_latitude && current_crs_option"
                      >
                        <v-col cols="3" class="import_modal_label text-center"
                          ><label
                            for="longitude"
                            v-html="
                              current_crs_option ==
                              GLOBAL.IMPORT.CRS_OPTIONS.WGS1984
                                ? $t('common.loadingDialog.longitude')
                                : current_crs_option ==
                                  GLOBAL.IMPORT.CRS_OPTIONS.HK1980
                                ? $t('common.easting')
                                : ''
                            "
                          >
                          </label
                        ></v-col>
                        <v-col cols="9">
                          <!-- <v-btn
                              :class="
                                'import_modal_button' +
                                (current_longitude == null ? ' error' : '')
                              "
                              @click="current_longitude = null"
                              >{{ $t("common.none") }}</v-btn
                            > -->

                          <v-btn
                            :class="
                              'import_modal_button' +
                              (current_longitude == selectabledItem
                                ? ' success'
                                : '')
                            "
                            :key="selectabledItem"
                            v-for="selectabledItem in selectableHeaders"
                            @click="current_longitude = selectabledItem"
                            >{{ selectabledItem }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </template>

                    <v-container
                      fluid
                      v-if="
                        enableAutoMatchSearch && enableAutoMatchSearch_Location
                      "
                    >
                      <v-card>
                        <v-card-title
                          ><v-icon color="error">warning</v-icon
                          ><span>{{
                            $t("common.importDialog.reminder")
                          }}</span></v-card-title
                        >
                        <v-card-text style="padding: 5px; color: red">
                          <v-row
                            v-if="
                              enableAutoMatchSearch &&
                              enableAutoMatchSearch_Location
                            "
                            class="import_modal_option_row"
                          >
                            <v-col
                              v-if="
                                reachBatchLocationSearchMaxCSVItems &&
                                enableAutoMatchSearch_Location
                              "
                              cols="12"
                              class="import_modal_label red--text"
                              >{{
                                $t("common.loadingDialog.reachMaxMatchItems", {
                                  number: core.batchLocationSearchMaxCSVItems,
                                })
                              }}
                            </v-col>
                            <v-col
                              v-else
                              cols="12"
                              class="import_modal_label red--text"
                            >
                              <div
                                v-html="
                                  $t(
                                    'common.importDialog.confirmNotMatchCorrect'
                                  )
                                "
                              ></div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-container>

                    <v-row
                      class="import_modal_option_row"
                      id="csvAutoMatchFields"
                      ref="tour_step2"
                    >
                      <template
                        v-if="
                          enableAutoMatchSearch &&
                          enableAutoMatchSearch_Location &&
                          !reachBatchLocationSearchMaxCSVItems
                        "
                      >
                        <v-col cols="3" class="import_modal_label"
                          ><label for="longitude"
                            >{{ $t("common.importDialog.autoMatchField") }}
                          </label></v-col
                        >
                        <v-col cols="9">
                          <v-btn
                            :key="selectabledItem"
                            v-for="selectabledItem in selectableHeaders"
                            @click="
                              current_batchLocationSearch = selectabledItem
                            "
                            :class="
                              'import_modal_button' +
                              (current_batchLocationSearch == selectabledItem
                                ? ' success'
                                : '')
                            "
                            >{{ selectabledItem }}</v-btn
                          >
                        </v-col>
                      </template>

                      <template
                        v-if="
                          enableAutoMatchSearch &&
                          enableAutoMatchSearch_Location &&
                          tourRunning &&
                          reachBatchLocationSearchMaxCSVItems
                        "
                      >
                        <img
                          :src="`./img/${
                            this.core.locate == GLOBAL.LANG.EN
                              ? 'csv_auto_match_tour_en.png'
                              : 'csv_auto_match_tour_chi.png'
                          }`"
                        />
                      </template>

                      <div class="csv-img-en"></div>
                      <div class="csv-img-zh"></div>
                    </v-row>
                  </v-sheet>

                  <!-- CRS system -->
                  <!-- 20210105  Hide the option “Coordinate Reference System” -- Terry Tse -->
                </v-card>
              </template>

              <!-- error message -->
              <template
                v-if="
                  !verifyFileDataErrorResult.result &&
                  verifyFileDataErrorResult.error_message.length > 0
                "
              >
                <v-card
                  style="width: 100%"
                  class="import_modal_error"
                  :key="err.error_message"
                  v-for="err in verifyFileDataErrorResult.error_message"
                >
                  <v-card-title
                    ><v-icon color="red">warning</v-icon
                    >{{ $t("common.importDialog.foundProblem") }}</v-card-title
                  >
                  <v-card-text class="import_modal_error_message red--text">{{
                    err.error_message
                  }}</v-card-text>
                  <v-card-text
                    class="import_modal_error_sub_message red--text"
                    v-html="err.error_sub_message"
                  ></v-card-text>
                </v-card>
              </template>

              <!-- info message -->
              <template
                v-if="
                  !verifyFileDataInfoResult.result &&
                  verifyFileDataInfoResult.error_message.length > 0
                "
              >
                <v-card
                  style="width: 100%"
                  class="import_modal_error"
                  :key="err.error_message"
                  v-for="err in verifyFileDataInfoResult.error_message"
                >
                  <v-card-title
                    ><v-icon color="secondary">info</v-icon
                    >{{ $t("common.importDialog.foundInfo") }}</v-card-title
                  >
                  <v-card-text class="import_modal_error_message red--text">{{
                    err.error_message
                  }}</v-card-text>
                  <v-card-text
                    class="import_modal_error_sub_message red--text"
                    v-html="err.error_sub_message"
                  ></v-card-text>
                </v-card>
              </template>
            </v-row>
            <!-- 20210105  Mask “***Support WGS84 & HK80 CRS Only***” -- Terry Tse
        <b-row>
          <v-chip class="ma-2" small label color="#FFF">{{
            $t("common.supportCRSMessage")
          }}</v-chip>
        </b-row>
        -->
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large text @click="import_modal = false">{{
            $t("common.cancel")
          }}</v-btn>
          <v-btn
            class="importDialogOKButton"
            large
            color="primary"
            :disabled="disableImportOK"
            @click="before_start_import"
            >{{ $t("common.ok") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script src="./lib/leaflet.js"></script>
<script>

// import {Map, View} from 'ol';
// import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
// import OSM from 'ol/source/OSM';
import Vector from 'ol/source/Vector';
import GML32 from 'ol/format/GML32';
import GML3 from 'ol/format/GML3';
import GML2 from 'ol/format/GML2';
import GML from 'ol/format/GML';

import {
  IMPORT,
  HIDDEN_FIELD_LABELS,
  CRS_TO_EPSG,
  MAP_KEY,
  MAP_LAYER,
} from "./Global.js";
import * as GLOBAL from "./Global.js";
import convert from "xml-js";
import localforage from "localforage";
import Papa from "papaparse";
// import FilterFacType from "./FilterFacType.js";
import FilterFacTypeSkip from "./FilterFacTypeSkip.js";
import  { DOMParser, XMLSerializer } from 'xmldom';

export default {
  data() {
    return {
      GLOBAL: GLOBAL,

      enableRunInBackground: false,

      file: null,
      loadedFile: null,
      verifyFileDataErrorResult: { result: false, error_message: [] },
      verifyFileDataInfoResult: { result: false, error_message: [] },

      formats: IMPORT.FORMATS,
      formatsArray: IMPORT.FORMATS_ARRAY,
      options: IMPORT.OPTIONS_ARRAY,
      crs_options: IMPORT.CRS_OPTIONS_ARRAY,

      current_format: IMPORT.FORMATS.CSV,
      current_option: IMPORT.OPTIONS.APPEND,
      // current_crs_option: IMPORT.CRS_OPTIONS.WGS1984,
      current_crs_option: null,
      current_latitude: null,
      current_longitude: null,

      //batch location seach
      current_batchLocationSearch: null,
      enableAutoMatchSearch: false,
      enableAutoMatchSearch_Location: false,
      tmpCSVData: [],
      loadingDialog: {
        visible: false,
        abortAutoMatch: false,
        tasks: 0,
        completedTasks: 0,
        successMatchTasks: 0,
        connectFailedTasks: 0,
        readyShowToast: true,
      },

      import_modal: false,

      // showing the selectable column for latitude & longitude
      selectableHeaders: [],

      fileErrorMessage: "",

      tour_intervalID: null,

      notAllowBackdropClose: false,

      isCSVAutoMatchRunning: false,

      tourRunning: false,

      verifyFile: {
        file: null,
        CSV: { status: null, featureGroup: null },
        GeoJSON: { status: null, featureGroup: null },
        KML: { status: null, featureGroup: null },
        GML: { status: null, featureGroup: null },
      },
    };
  },
  props: ["core", "tour"],

  computed: {
    reachBatchLocationSearchMaxCSVItems() {
      return (
        this.enableAutoMatchSearch &&
        this.enableAutoMatchSearch_Location &&
        this.tmpCSVData &&
        this.tmpCSVData.length > this.core.batchLocationSearchMaxCSVItems
      );
    },

    disableImportOK() {
      //empty file
      if (this.file && this.file.size <= 0) {
        return true;
      }

      if (
        !this.verifyFileDataErrorResult.result &&
        this.verifyFileDataErrorResult.error_message.length > 0
      ) {
        return true;
      }

      if (
        this.file == null ||
        this.current_format == null ||
        this.current_option == null
      ) {
        return true;
      }

      if (
        this.current_format == GLOBAL.IMPORT.FORMATS.CSV &&
        this.enableAutoMatchSearch
      ) {
        if (this.enableAutoMatchSearch_Location) {
          if (
            !this.current_batchLocationSearch ||
            this.reachBatchLocationSearchMaxCSVItems
          ) {
            return true;
          }
        } else {
          if (
            this.current_latitude == null ||
            this.current_longitude == null ||
            this.current_option == null
          ) {
            return true;
          }
        }
      }

      return false;
    },
  },

  watch: {
    async file(newVal, oldVal) {
      //reset column header
      this.selectableHeaders = [];
      //reset current_format
      this.current_format = null;
      // this.current_format = this.GLOBAL.IMPORT.FORMATS.CSV;
      if (newVal != oldVal && newVal) {
        let layers = await this.loadAndCheckFile();
        this.verifyFileData(layers);
      }

      // else {
      //   this.reset_import_modal();
      // }
    },

    current_crs_option() {
      this.csvAutoSelectField();
    },

    current_format(val) {
      if (val && this.file) {
        let layers = this.checkFileSpecificFormat({
          format: this.current_format,
        });
        this.verifyFileData(layers);
      }
      this.csvAutoSelectField();
    },
  },

  mounted() {
  },

  methods: {
    verifyFileIsXML(target) {
      let result = false
      try {
        result = convert.xml2json(target ? target : this.loadedFile, {
            compact: false,
        });
      } catch (e) { }
      
      return result
    },

    verifyAndGetNewColumnName(colName) {
      let tmpNewColumnName = colName;
      if (!this.core.isNotHiddenField(tmpNewColumnName)) {
        tmpNewColumnName = "_" + tmpNewColumnName;
      }

      return tmpNewColumnName;
    },

    existNonPointData(layer) {
      // console.log("existNonPointData")

      let result = false;

      //leaflet
      if (
        layer.hasOwnProperty("feature") &&
        layer.feature.type != "Point" &&
        layer.feature.type != "Feature"
      ) {
        result = true;
      }

      if (
        layer.hasOwnProperty("feature") &&
        layer.feature.type == "Feature" &&
        layer.feature.hasOwnProperty("geometry") &&
        layer.feature.geometry &&
        layer.feature.geometry.type != "Point"
      ) {
        result = true;
      }

      //openlayer (gml)
      if (layer.hasOwnProperty("ol_uid")) {
        if (layer.getGeometry() && layer.getGeometry().getType() != "Point") {
          result = true;
        }

        // console.log(layer);

        if (
          typeof layer.getProperties == "function" &&
          layer.getProperties().geometryProperty &&
          Object.keys(layer.getProperties().geometryProperty).filter(
            (item) => item != "Point"
          ).length > 0
        ) {
          result = true;
        }
      }
      return result;
    },

    //support for tpb geojson case
    getLayersFromGeoJSON(json) {
      let layers = [];
      if (typeof json == "object") {
        if (!json.hasOwnProperty("features")) {
          for (let key in json) {
            if (json[key].hasOwnProperty("features")) {
              layers.push(json[key]);
            }
          }
        } else {
          layers.push(json);
        }
      }

      return layers;
    },

    getFeaturesFromGeoJSON(json) {
      let features = [];

      let layers = this.getLayersFromGeoJSON(json);

      layers.forEach((layer) => {
        if (layer.hasOwnProperty("features")) {
          features.push(...layer.features);
        }
      });

      return features;
    },

    csvAutoSelectField() {
      let current_latitude_field = null,
        current_longitude_field = null;
      for (let i = 0; i < this.selectableHeaders.length; i++) {
        let selectableHeader = this.selectableHeaders[i]
          .toString()
          .toLowerCase();

        let y_match =
          this.current_crs_option == IMPORT.CRS_OPTIONS.WGS1984
            ? IMPORT.LATITIDE_MATCH
            : IMPORT.HK80Y_MATCH;

        for (let j = 0; j < y_match.length; j++) {
          let lat_match = y_match[j].toString().toLowerCase();
          if (lat_match == selectableHeader) {
            current_latitude_field = lat_match;
          }
        }

        let x_match =
          this.current_crs_option == IMPORT.CRS_OPTIONS.WGS1984
            ? IMPORT.LONGITUDE_MATCH
            : IMPORT.HK80X_MATCH;

        for (let j = 0; j < x_match.length; j++) {
          let lng_match = x_match[j].toString().toLowerCase();
          if (lng_match == selectableHeader) {
            current_longitude_field = lng_match;
          }
        }
      }

      if (current_latitude_field) {
        this.current_latitude = current_latitude_field;
      }
      if (current_longitude_field) {
        this.current_longitude = current_longitude_field;
      }
    },

    presetLayerOptionsBuilder({
      id,
      url,
      layers,
      layerDefs,
      outputType,
      dynamicLayers,
    }) {
      return {
        url: `${url}?key=${MAP_KEY}`,
        id: MAP_LAYER.NAME.BUILDING_LAYER,
        useCors: false,
        key: MAP_KEY,
        renderer: L.canvas(),
        transparent: true,
        format: "png32",
        layers: layers,
        dynamicLayers: JSON.stringify(dynamicLayers),
        bboxSR: 4326,
        imageSR: 4326,
        f: !outputType ? "json" : outputType,
        layerDefs: layerDefs,
        code: CRS_TO_EPSG.WGS1984,
      };
    },

    verifyFileData(layers) {

      //error_message => [error_type: {error_message: "xyz", error_sub_message: "abc"}, {}...]
      const error = { result: true, error_message: [] };
      const info = { result: true, error_message: [] };
      const error_system_hold_col_name_list = [];
      const error_convert_number_list = [];
      const error_convert_date_list = [];
      const error_non_point_data_list = [];

      if (this.loadedFile == null) {
        //check whether compatible with file and format
      } else if (!layers || layers.length == 0) {
        error.result = false;

        error.error_message.push({
          error_message: this.$t(
            "common.importDialog.fileAndFormatIncompatible"
          ),
        });
      } else {
        //check whether acceptable field name &
        //check data whether availble for specfic date format
        //geojson
        for (let i = 0; i < layers.length; i++) {
          let layer = layers[i];

          // console.log(layers[i]);

          //checking non point data
          if (this.existNonPointData(layer)) {
            error_non_point_data_list.push(layer);
          }

          if (this.current_format == this.formats.GEOJSON) {
            if (layer.hasOwnProperty("properties")) {
              layer = layer.properties;
            } else {
              continue;
            }
          }

          // for (const key in layer) {
          //   //verify number or date
          //   for (let j = 0; j < this.core.dynamicFields.length; j++) {
          //     let dynamicField = this.core.dynamicFields[j];
          //     if (dynamicField.label === key) {
          //       switch (dynamicField.type) {
          //         case this.GLOBAL.FIELD_TYPES.DATE:
          //           if (!this.core.verifyConvertDate(layer[key])) {
          //             if (!error_convert_date_list.hasOwnProperty(key)) {
          //               error_convert_date_list[key] = [];
          //             }

          //             error_convert_date_list[key].push(JSON.stringify(layer));
          //           }
          //           break;
          //         case this.GLOBAL.FIELD_TYPES.NUMBER:
          //           if (!this.core.verifyConvertNumber(layer[key])) {
          //             if (!error_convert_number_list.hasOwnProperty(key)) {
          //               error_convert_number_list[key] = [];
          //             }

          //             error_convert_number_list[key].push(
          //               JSON.stringify(layer)
          //             );
          //           }
          //           break;
          //       }
          //     }
          //   }
          // }
        }

        if (error_non_point_data_list.length > 0) {
          info.result = false;
          info.error_message.push({
            error_message: this.$t("common.importDialog.nonPointData"),
          });
        }

        if (error_system_hold_col_name_list.length > 0) {
          error.result = false;
          error.error_message.push({
            error_message:
              this.$t("common.importDialog.systemholdcolumnname") + ":",
            error_sub_message: error_system_hold_col_name_list.join(", "),
          });
        }

        if (Object.keys(error_convert_date_list).length > 0) {
          error.result = false;

          let message = "";
          for (let key in error_convert_date_list) {
            message +=
              this.$t("common.column") +
              `: <b>${key} </b><div class='import_modal_error_sub_message_list'>`;

            message += error_convert_date_list[key]
              .map(function (item) {
                return `<div class='import_modal_error_sub_message_list_item'>${item}</div>`;
              })
              .join("");
          }
          message += "</div>";

          error.error_message.push({
            error_message:
              this.$t("common.importDialog.convertDateTypeFailed") + ":",
            error_sub_message: message,
          });
        }

        if (Object.keys(error_convert_number_list).length > 0) {
          result.result = false;

          let message = "";
          for (let key in error_convert_number_list) {
            message +=
              this.$t("common.column") +
              `: <b>${key} </b><div class='import_modal_error_sub_message_list'>`;
            message += error_convert_number_list[key]
              .map(function (item) {
                return `<div class='import_modal_error_sub_message_list_item'>${item}</div>`;
              })
              .join("");
          }
          message += "</div>";

          error.error_message.push({
            error_message:
              this.$t("common.importDialog.convertNumberTypeFailed") + ":",
            error_sub_message: message,
          });
        }
      }

      this.verifyFileDataErrorResult = error;
      this.verifyFileDataInfoResult = info;
    },

    async show_import_modal(files) {
      this.$GA.import_open();

      this.fileErrorMessage = "";

      files = files || null;

      // this.$refs["import_modal"].show();
      this.import_modal = true;

      //for drag drop file
      if (files != null && files.length == 1) {
        this.file = files[0];
        await this.loadAndCheckFile();
      }

      if ((await localforage.getItem("showImportTour")) !== false) {
        this.core.tour2.runImportSteps();
        localforage.setItem("showImportTour", false);
      }

      //set the overlay z-index to 1002 to cover left bar menu
      $(".v-overlay").css("z-index", "1002");
    },

    updataCurrentFormat(format) {
      this.current_format = format;
    },

    generateCSVHeaders(loadedFile) {
      try {
        let loadedCSVData = this.loadCSV(loadedFile);

        this.selectableHeaders = loadedCSVData.meta.fields;

        return {
          result: true,
          fields: this.selectableHeaders,
        };
      } catch (err) {
        console.log(err);
        return;
      }
    },

    generateSelectableHeaders() {
      if (this.loadedFile == null) {
        return;
      }
      this.current_longitude = null;
      this.current_latitude = null;

      try {
        let result = this.generateCSVHeaders(this.loadedFile);

        if (result.result) {
          this.selectableHeaders = result.fields;
          this.current_latitude = result.latitude_field;
          this.current_longitude = result.longitude_field;
        } else {
          return;
        }
      } catch (err) {
        console.log(err);
        return;
      }
    },

    checkFileSpecificFormat({ format }) {
      let layers = [],
        featureGroup = null;

      if (this.loadedFile == null) {
        return layers;
      }

      if (this.verifyFile.file == this.loadedFile) {
        if (this.verifyFile[format].status == "loading") {
          return layers;
        }

        if (this.verifyFile[format].status == "completed") {
          if (this.verifyFile[format].featureGroup) {
            return this.verifyFile[format].featureGroup.getLayers();
          } else if (format != this.formats.CSV) {
            return layers;
          }
        }
      } else {
        this.verifyFile.file = this.loadedFile;
        this.verifyFile[format].status = "loading";
      }

      try {
        switch (format) {
          case this.formats.GML:
            let gmlFeatures = this.loadGML(this.loadedFile);
            let geoJSON = JSON.parse(
              new ol.format.GeoJSON().writeFeatures(gmlFeatures)
            );

            featureGroup = this.createCRSLayer(
              geoJSON,
              // me.current_crs_option,
              null,
              null,
              true
            );

            layers = featureGroup.getLayers();

            //fix for qgis gml32
            if (layers.length == 0) {
              if (
                geoJSON.type == "FeatureCollection" &&
                geoJSON.features.length > 0
              ) {
                geoJSON.features.forEach((feature) => {
                  if (
                    feature.properties &&
                    feature.properties.geometryProperty &&
                    feature.properties.geometryProperty.Point
                  ) {
                    feature["geometry"] = {
                      type: "Point",
                      coordinates:
                        feature.properties.geometryProperty.Point._content_.coordinates.split(
                          ","
                        ),
                    };

                    delete feature.properties.geometryProperty;
                  }
                });

                featureGroup = this.createCRSLayer(
                  geoJSON,
                  // me.current_crs_option,
                  null,
                  null,
                  true
                );

                layers = featureGroup.getLayers();
              }
            }

            break;
          case this.formats.KML:
            // layers = omnivore.kml.parse(this.loadedFile).getLayers();

            featureGroup = this.createCRSLayer(
              omnivore.kml.parse(this.loadedFile).toGeoJSON(),
              // me.current_crs_option,
              GLOBAL.IMPORT.CRS_OPTIONS.WGS1984,
              null,
              true
            );

            layers = featureGroup.getLayers();

            break;
          case "GPX":
            layers = omnivore.gpx.parse(this.loadedFile).getLayers();
            break;
          case "TopoJSON":
            layers = omnivore.topojson.parse(this.loadedFile).getLayers();
            break;
          case "WKT":
            layers = omnivore.wkt.parse(this.loadedFile).getLayers();
            break;
          case this.formats.GEOJSON:
            let json = JSON.parse(this.loadedFile);
            this.getLayersFromGeoJSON(json).forEach((layerFromGeoJSON) => {
              let tmpFeatureGroup = this.createCRSLayer(
                layerFromGeoJSON,
                // me.current_crs_option,
                null,
                this.current_format,
                true
              );

              if (featureGroup == null) {
                featureGroup = tmpFeatureGroup;
              } else {
                tmpFeatureGroup.getLayers().forEach((layer) => {
                  featureGroup.addLayer(layer);
                });
              }
            });

            layers = featureGroup.getLayers();

            break;
          case this.formats.CSV:
            let result = this.loadCSV(this.loadedFile);
            this.tmpCSVData = result.data;
            layers = result.data;
            // featureGroup = result.data;
            this.generateSelectableHeaders();
            break;
        }
        // this.verifyFile.file = this.loadedFile;
        if (layers.length > 0) {
          this.verifyFile[format] = {
            status: "completed",
            featureGroup: featureGroup,
          };
        }
      } catch (error) {
        console.log(error);
        this.verifyFile[format] = {
          status: "error",
          featureGroup: null,
        };
      }

      return layers;
    },

    checkFile(_isShapeFile, _skipSelectionFormat, _file) {
      let isShapeFile = _isShapeFile || false,
        skipSelectionFormat = _skipSelectionFormat || false,
        updataCurrentFormat = this.updataCurrentFormat,
        layers = [];

      let extension = _file.name.split(".").pop();

      let sortedFormatsArray = this.formatsArray.sort((a, b) => {
        switch (extension) {
          case "json":
          case "geojson":
            if (a == IMPORT.FORMATS.GEOJSON) {
              return -1;
            }
            if (b == IMPORT.FORMATS.GEOJSON) {
              return 1;
            }
            break;
          case "txt":
          case "csv":
            if (a == IMPORT.FORMATS.CSV) {
              return -1;
            }
            if (b == IMPORT.FORMATS.CSV) {
              return 1;
            }
            break;
          case "kml":
            if (a == IMPORT.FORMATS.KML) {
              return -1;
            }
            if (b == IMPORT.FORMATS.KML) {
              return 1;
            }
            break;
          case "gml":
          case "xml":
            if (a == IMPORT.FORMATS.GML) {
              return -1;
            }
            if (b == IMPORT.FORMATS.GML) {
              return 1;
            }
            break;
          default:
            return 0;
        }
      });

      //Skip some checking of file format
      //if the file is xml

      if (this.verifyFileIsXML()) {
        sortedFormatsArray = sortedFormatsArray.filter((f) => {
          switch (f) {
            case this.formats["CSV"]:
            case this.formats["GEOJSON"]:
              return false;
            default:
              return true;
          }
        });
      }

      for (let i = 0; i < sortedFormatsArray.length; i++) {
        try {
          if (isShapeFile) {
            // switch (this.formats[format_index]) {
            //   case "Shapefile":
            //     let format = this.formats[format_index];
            //     // console.log(shp)
            //     shp(e.target.result).then(function (json) {
            //       // console.log("shp");
            //       layers = L.geoJson(json.features).getLayers();
            //       if (layers.length > 0) {
            //         // console.log(this.formats[format_index])
            //         updataCurrentFormat(format);
            //       } else {
            //         return null;
            //       }
            //     });
            //     break;
            // }
          } else {
            layers = this.checkFileSpecificFormat({
              format: sortedFormatsArray[i],
            });
          }

          if (layers && layers.length > 0) {
            if (!skipSelectionFormat) {
              updataCurrentFormat(sortedFormatsArray[i]);
            }
            return layers;
          }
        } catch (err) {
          console.log(err);
          continue;
        }
      }

      return layers;
    },

    //event is for drag drop file only
    async loadAndCheckFile(_event, _skipSelectionFormat) {
      return new Promise((resolve, reject) => {
        try {
          let event = _event || null,
            skipSelectionFormat = _skipSelectionFormat || false,
            reader = new FileReader(),
            me = this;

          //for drag file to input file

          if (event && event.dataTransfer && event.dataTransfer.files) {
            me.file =
              event.dataTransfer.files.length > 0
                ? event.dataTransfer.files[0]
                : me.file;
          }

          reader.onload = async function (e) {
            const jschardet = require("jschardet");
            const iconv = require("iconv-lite");

            //empty file
            if (e.target.result.byteLength <= 0) {
              reader.onerror = reject();
              return false;
            }

            const buffer = Buffer.from(e.target.result);
            const type = jschardet.detect(buffer);
            const res = iconv.decode(buffer, type.encoding);

            me.loadedFile = res;
            resolve(me.checkFile(false, skipSelectionFormat, me.file));
          };

          reader.onerror = reject();

          me.loadedFile = null;
          if (me.file != null) {
            // reader.readAsText(me.file);
            reader.readAsArrayBuffer(me.file);
          }
        } catch (e) {
          console.log(e);
        }
      });
    },

    loadCSV(eTargetResult) {
      //ignore if xml file
      if (this.verifyFileIsXML(eTargetResult)) {
        return false
      }

      try {
        return Papa.parse(eTargetResult, {
          delimiter: ",",
          quoteChar: '"',
          escapeChar: '"',
          header: true,
          skipEmptyLines: true,
        });
      } catch (err) {
        console.log(err);
        return null;
      }
    },
    updateGmlSrsName(xml) {
      
      const doc = new DOMParser().parseFromString(
       xml,
        'text/xml'
        )

        // fit GDAL change <ogr:featureMember> -> <gml:featureMember> 
        Array.prototype.forEach.call(doc.getElementsByTagNameNS("*", 'featureMember'), (element) => { element.tagName = 'gml:featureMember'} );
        
        //fix xy bug
        Array.prototype.forEach.call(doc.getElementsByTagNameNS("*", 'Point'), (element) => { element.setAttribute('srsName', CRS_TO_EPSG.WGS1984)} );
        return new XMLSerializer().serializeToString(doc)
    },
    loadGML(eTargetResult) {
      let xmlJSON = this.GMLUpdateAttributes(
          JSON.parse(
            convert.xml2json( this.updateGmlSrsName(eTargetResult), {
      //  convert.xml2json( eTargetResult, {
              // ignoreComment: true,
              // ignoreCdata: true,
              compact: false,
            })
          )
        ),

      
        revisedXML = convert.json2xml(xmlJSON);

      //read xml
      const xmlJquery = $($.parseXML(revisedXML));
      const foundList = xmlJquery.find("[srsName]");
      let srsName = null;

      if (foundList && foundList.length > 0) {
        srsName = foundList.attr("srsName");
      }

      let gmlFeatures = null;
      let options = {
        // featureNS: "geodatastore",
        // featureType: null,
        // srsName: CRS_TO_EPSG.HK1980,
        // srsName: srsName ? srsName : null,
      };

      /*

    export const CRS_TO_EPSG = {
     WGS1984: "EPSG:4326",
     HK1980: "EPSG:2326",
    };

      */
      let featureOptions = {
        dataProjection: srsName ? srsName : null,
        featureProjection: CRS_TO_EPSG.WGS1984,
      };
    //  console.log('featureOptions '+ JSON.stringify(featureOptions) ) 
      // console.log(featureOptions)
      // if (this.current_crs_option == IMPORT.CRS_OPTIONS.HK1980) {
      //   options = {
      //     dataProjection: EPSG.HK80_EPSG,
      //     featureProjection: EPSG.WGS_EPSG,
      //     srsName: EPSG.HK80_EPSG,
      //   };
      // } else if (this.current_crs_option == IMPORT.CRS_OPTIONS.WGS1984) {
      //   options = {
      //     dataProjection: EPSG.WGS_EPSG,
      //     featureProjection: EPSG.WGS_EPSG,
      //     srsName: EPSG.WGS_EPSG,
      //   };
      // }      

      try {
        gmlFeatures = new GML32(options).readFeatures(
          revisedXML,
          featureOptions
        );

        if (gmlFeatures && gmlFeatures.length > 0) {

          for (const gmlFeature of gmlFeatures) {
            const keys = gmlFeature.getKeys();
            // console.log(keys)
            for (const key of keys) {
              const keyVal = gmlFeature.get(key)
              if (keyVal == undefined || keyVal == null) {
                gmlFeature.set(key, "")
              }
            }
          }

          const vectorSource = new Vector({
          })

          vectorSource.addFeatures(gmlFeatures)

          
          const vectorLayer = new Vector({
            source: vectorSource
          })

          this.core.olMap.addLayer(vectorLayer)
          this.core.olMap.removeLayer(vectorLayer)
          this.core.layerName = this.GetGMLFeatureName(xmlJSON);

          return gmlFeatures;
        }
      } catch (e) {
        console.log(e);
      }

      try {

        gmlFeatures = new GML3(options).readFeatures(
          revisedXML,
          featureOptions
        );

        // if (gmlFeatures && gmlFeatures.length > 0) {
          // console.log("GML3", gmlFeatures, featureOptions);

          for (const gmlFeature of gmlFeatures) {
            const keys = gmlFeature.getKeys();
            // console.log(keys)
            for (const key of keys) {
              const keyVal = gmlFeature.get(key)
              if (keyVal == undefined || keyVal == null) {
                gmlFeature.set(key, "")
              }
            }
          }

          // console.log(gmlFeatures)

          const vectorSource = new Vector({
          })

          vectorSource.addFeatures(gmlFeatures)

          const vectorLayer = new Vector({
            source: vectorSource
          })

          this.core.olMap.addLayer(vectorLayer)
          this.core.olMap.removeLayer(vectorLayer)
          this.core.layerName = this.GetGMLFeatureName(xmlJSON);

          return gmlFeatures;
        // }
      } catch (e) {
        console.log(e);
      }

      // try {
      //   gmlFeatures = new WFS({
      //     gmlFormat: new GML2(options),
      //   }).readFeatures(revisedXML, featureOptions);

      //   // console.log("WFS", gmlFeatures);
      //   if (gmlFeatures && gmlFeatures.length > 0) {
      //     console.log("WFS + GML2", gmlFeatures);
      //     return gmlFeatures;
      //   }
      // } catch (e) {
      //   console.log(e);
      // }

      try {
        gmlFeatures = new GML2(options).readFeatures(
          revisedXML,
          featureOptions
        );
        if (gmlFeatures && gmlFeatures.length > 0) {

          for (const gmlFeature of gmlFeatures) {
            const keys = gmlFeature.getKeys();
            // console.log(keys)
            for (const key of keys) {
              const keyVal = gmlFeature.get(key)
              if (keyVal == undefined || keyVal == null) {
                gmlFeature.set(key, "")
              }
            }
          }

          const vectorSource = new Vector({
          })

          vectorSource.addFeatures(gmlFeatures)

          const vectorLayer = new Vector({
            source: vectorSource
          })

          this.core.olMap.addLayer(vectorLayer)
          this.core.olMap.removeLayer(vectorLayer)
          this.core.layerName = this.GetGMLFeatureName(xmlJSON);

          return gmlFeatures;
        }
      } catch (e) {
        console.log(e);
      }

      try {
        gmlFeatures = new GML(options).readFeatures(
          revisedXML,
          featureOptions
        );

        if (gmlFeatures && gmlFeatures.length > 0) {
          
          for (const gmlFeature of gmlFeatures) {
            const keys = gmlFeature.getKeys();
            // console.log(keys)
            for (const key of keys) {
              const keyVal = gmlFeature.get(key)
              if (keyVal == undefined || keyVal == null) {
                gmlFeature.set(key, "")
              }
            }
          }

          const vectorSource = new Vector({
          })

          vectorSource.addFeatures(gmlFeatures)

          const vectorLayer = new Vector({
            source: vectorSource
          })

          this.core.olMap.addLayer(vectorLayer)
          this.core.olMap.removeLayer(vectorLayer)
          this.core.layerName = this.GetGMLFeatureName(xmlJSON);

          return gmlFeatures;
        }
      } catch (e) {
        console.log(e);
      }

      return null;
    },

    /**
     * @param {Object} xml 
     * @returns {string}
     */
    GetGMLFeatureName(xml) {
      if (!xml.elements && !(xml.elements instanceof Array) && xml.elements.length == 0)
        throw "GML without elements";
      
      if (!xml.elements[0].name.includes('FeatureCollection'))
        throw "Not supported format"

      let tags = xml.elements[0].elements;
      if (!(tags instanceof Array))
        throw "GML not found elements"

      /** @type {Set<String>} */
      const nameList = new Set();
      
      tags.forEach(element => {
        if (
          !element.name.includes('featureMember') &&
          !element.name.includes('member')
        ) {
          return;
        }
        if (element.elements[0]) {
          nameList.add(element.elements[0].name);
        }
      });
      
      if (nameList.size != 1) {
        throw "GML have multiple layer which is not supported.";
      }

      const iter = nameList.keys();
      const featureName = iter.next().value;
      if (typeof featureName != "string")
        return "";

      let result = featureName;
      if (result.includes(":"))
        result = featureName.split(":")[1];
      
      return result;
    },

    GMLUpdateAttributes(xmlJSON) {
      if (xmlJSON.hasOwnProperty("elements")) {
        for (let i = 0; i < xmlJSON.elements.length; i++) {
          let xmlJSONItem = xmlJSON.elements[i];
          // console.log(xmlJSONItem);
          if (xmlJSONItem.hasOwnProperty("attributes")) {
            let newAttr = {};
            for (let attribute in xmlJSONItem.attributes) {

              if (attribute.search(/^xmlns/g) > -1) {
                newAttr[attribute] = xmlJSONItem.attributes[attribute];
              } else if (attribute.search(/^srsDimension/g) > -1) {
                newAttr[attribute] = xmlJSONItem.attributes[attribute];
              } else if (attribute.search(/^srsName/g) > -1) {
                newAttr[attribute] = xmlJSONItem.attributes[attribute];

              }
            }

            xmlJSONItem.attributes = newAttr;
          }

          this.GMLUpdateAttributes(xmlJSONItem);
        }
      }

      return xmlJSON;
    },

    reset_import_modal() {
      this.file = null;
      this.current_format = IMPORT.FORMATS.CSV;
      this.current_option = IMPORT.OPTIONS.APPEND;
      // this.current_crs_option = IMPORT.CRS_OPTIONS.WGS1984;
      this.current_crs_option = null;
      this.selectableHeaders = [];
      this.current_latitude = null;
      this.current_longitude = null;
      this.verifyFileDataErrorResult = { result: false, error_message: [] };
      this.verifyFileDataInfoResult = { result: false, error_message: [] };
      this.enableAutoMatchSearch = false;
      this.enableAutoMatchSearch_Location = false;
      this.current_batchLocationSearch = null;
      this.loadingDialog = {
        visible: false,
        abortAutoMatch: false,
        tasks: 0,
        completedTasks: 0,
        successMatchTasks: 0,
        connectFailedTasks: 0,
      };
    },

    attachRefLayerListener({ refLayer, tableItem }) {
      let me = this;

      refLayer.setStyle(this.GLOBAL.LAYER_STYLE.TABLE_LAYER);
      // refLayer.bringToBack();

      refLayer.on("click", (e) => {
        // console.log("mouseover");
        if (me.core.enableIdentify) {
          me.core.updateCurrentSelectedTableItem({ tableItem: tableItem });
        }
      });

      refLayer.on("mouseover", (e) => {
        // console.log("mouseover");
        refLayer.setStyle(me.GLOBAL.LAYER_STYLE.TABLE_LAYER_HIGHTLIGHTED);
      });

      refLayer.on("mouseout", (e) => {
        // console.log("mouseover");

        if (
          me.core.currentSelectedTableItem &&
          tableItem.leaflet_id == me.core.currentSelectedTableItem.leaflet_id
        ) {
          refLayer.setStyle(me.GLOBAL.LAYER_STYLE.TABLE_ITEM_LAYER_SELECTED);
        } else {
          refLayer.setStyle(me.GLOBAL.LAYER_STYLE.TABLE_LAYER);
        }
      });
    },

    attachTableLayerListener(layer, type) {
      let me = this;

      if (
        (layer._latlng && type == "marker") ||
        (layer.hasOwnProperty("feature") &&
          layer.feature.hasOwnProperty("geometry") &&
          layer.feature.geometry &&
          layer.feature.geometry.type == "Point")
      ) {
        layer.on("click", (e) => {
          if (me.core.enableIdentify) {
            me.core.updateCurrentSelectedTableItem({
              tableItem: me.core.getTableItemByLeafletId(layer._leaflet_id),
            });
            me.core.goToTableItemByIndex({
              index: me.core.currentSelectedTableItem.index,
            });
          }
        });
      }
      return layer;
    },

    createEsriDrawingInfo() {
      return {
        drawingInfo: {
          transparency: 15,
          renderer: {
            type: "simple",
            symbol: {
              color: [220, 20, 60, 153],
              outline: {
                color: [0, 0, 0, 153],
                width: 3,
                type: "esriSLS",
                style: "esriSLSSolid",
                marker: null,
              },
              type: "esriSFS",
              style: "esriSFSSolid",
            },
          },
          showLabels: true,
        },
      };
    },

    attachOrginalLayerOptions() {
      let me = this;

      return {
        style: me.GLOBAL.LAYER_STYLE.TABLE_LAYER,

        //To determinate the point or circle
        pointToLayer(feature, latlng) {
          if (
            feature &&
            feature.hasOwnProperty("properties") &&
            feature.properties != null &&
            typeof feature.properties[HIDDEN_FIELD_LABELS.RADIUS] !==
              "undefined"
          ) {
            return new L.Circle(
              latlng,
              feature.properties[HIDDEN_FIELD_LABELS.RADIUS]
            );
          } else {
            return new L.Marker(latlng, {});
          }
        },

        onEachFeature(feature, layer) {},
      };
    },

    attachCustomLayerOptions(style) {
      // console.log(style);
      let me = this,
        fillColor = null;
      // console.log(style)
      if (
        style &&
        typeof style.fillColor == "object" &&
        style.fillColor != null &&
        typeof style.fillColor.hexa == "string"
      ) {
        fillColor = style.fillColor.hexa;
      } else {
        fillColor = "red";
      }

      const initialStyle = {
        fillColor: fillColor,
        fillOpacity: 0.3,
        color: fillColor,
        opacity: 0.9,
        weight: 1,
        dashArray: "3",
      };

      const highlightedStyle = {
        fillColor: "grey",
        fillOpacity: 0.3,
        color: "white",
        opacity: 0.9,
        weight: 3,
        dashArray: "0",
      };

      const initialIcon = L.ExtraMarkers.icon({
        shape: "circle",
        markerColor: fillColor,
        prefix: "fa",
        // icon: "fa-certificate",
        icon: "fa-circle",
        iconColor: "#FFF",
        iconRotate: 0,
        extraClasses: "",
        number: "",
        svg: true,
      });

      return {
        //FOR MARKER
        pointToLayer: function (feature, latlng) {
          return L.marker(latlng, { icon: initialIcon });
        },
        // FOR SHAPE
        style: initialStyle,
        onEachFeature(feature, layer) {
          layer.on("click", (e) => {
            let html = "";
            for (let key in layer.feature.properties) {
              html += `${key} : ${layer.feature.properties[key]} <BR/>`;
            }

            if (typeof layer.getCenter == "function") {
              layer
                .bindPopup(html, {
                  // direction: "auto",
                  // permanent: false,
                  // opacity: 1,
                })
                .openPopup();
              // me.map.openTooltip(html, layer.getCenter());
            } else {
              layer
                .bindPopup(html, {
                  // direction: "auto",
                  // permanent: false,
                  // opacity: 1,
                })
                .openPopup();
            }
          });

          if (feature.geometry.type == "Point") {
            // console.log(layer);
            layer.setIcon(initialIcon);
          } else {
            layer.on("mouseover", (e) => {
              layer.bringToFront();
              layer.setStyle(highlightedStyle);
            });

            layer.on("mouseout", (e) => {
              layer.bringToBack();
              layer.setStyle(initialStyle);
            });
          }
        },
      };
    },

    createCRSLayer(orginialGeoJSON, _targetCRS, style, _usingOrginialStyle) {
      // console.log(orginialGeoJSON);

      let usingOrginialStyle = _usingOrginialStyle || false;
      let result = null;
      if (_targetCRS) {
        result = L.Proj.geoJson(
          this.addCrsOption(orginialGeoJSON, _targetCRS),
          usingOrginialStyle ? {} : { ...this.attachCustomLayerOptions(style) }
        );
      } else {
        result = L.Proj.geoJson(
          orginialGeoJSON,
          usingOrginialStyle ? {} : { ...this.attachCustomLayerOptions(style) }
        );
      }

      // console.log(result);

      return result;
    },

    //for layers
    addCrsOption(geoJSON, crsName) {
      geoJSON.crs = {
        type: "name",
        properties: {
          name: CRS_TO_EPSG[crsName],
        },
      };
      return geoJSON;
    },

    before_start_import() {
      if (this.enableAutoMatchSearch && this.enableAutoMatchSearch_Location) {
        this.core.clearConfirmDialog();

        this.core.confirmDialogTitle = this.$t("common.attention");
        this.core.confirmDialogWarningTitleIcon = true;

        this.core.confirmDialogMessage = this.$t(
          "common.importDialog.confirmNotMatchCorrect"
        );
        this.core.confirmDialogOK = () => {
          this.start_import();
        };
        this.core.confirmDialog = true;
      } else {
        this.start_import();
      }
    },

    async start_import() {
      let process_import = this.process_import,
        me = this;

      switch (this.current_format) {
        case this.formats.GEOJSON:
          try {
            let featureGroup =
              this.verifyFile[this.formats.GEOJSON].featureGroup;

            this.core.checkIntersects(featureGroup, () => {
              if (this.current_option == IMPORT.OPTIONS.REPLACEALL) {
                this.core.deleteAllData(true);
              }

              this.process_import(featureGroup.getLayers(), true);
            });
          } catch (err) {
            this.process_import(null, false);
            console.log(err);
          }

          break;

        case this.formats.CSV:
          try {
            me.$GA.import_csv();

            let csv = me.loadCSV(this.loadedFile),
              csv_headers = csv.meta.fields,
              csv_items = csv.data;

            //start to review and update whether is at HIDDEN_FIELD_LABELS range
            for (let index in csv_headers) {
              let oldColumnName = csv_headers[index] + "";
              csv_headers[index] = me.verifyAndGetNewColumnName(
                csv_headers[index]
              );

              if (oldColumnName != csv_headers[index]) {
                for (let index2 in csv_items) {
                  if (csv_items[index2][oldColumnName]) {
                    let tmpValue = csv_items[index2][oldColumnName];
                    csv_items[index2][csv_headers[index]] = tmpValue;
                    delete csv_items[index2][oldColumnName];
                  }
                }
              }
            }

            // none selection of latitude and longitude
            if (
              !me.enableAutoMatchSearch ||
              (me.enableAutoMatchSearch &&
                !me.enableAutoMatchSearch_Location &&
                me.current_longitude == null &&
                me.current_latitude == null)
            ) {
              if (me.current_option == IMPORT.OPTIONS.REPLACEALL) {
                me.core.deleteAllData(true);
              }

              me.core.addItemsToTableDataByCSVWithoutLayer(
                csv_headers,
                csv_items
              );

              me.import_file_toast(true);
              // me.$refs["import_modal"].hide();
              me.import_modal = false;
              me.core.goToTableItemByIndex({
                index: me.core.tableItems.length,
              });

              return;
            } else {
              let newTableItems = [],
                newColumnNames = [],
                featureGroup = new L.featureGroup([]);

              for (let i = 0; i < csv_items.length; i++) {
                // console.log(i)
                let properties = {},
                  latitude = null,
                  longitude = null;

                for (let key in csv_items[i]) {
                  if (
                    !me.enableAutoMatchSearch_Location &&
                    me.verifyAndGetNewColumnName(me.current_latitude) == key
                  ) {
                    latitude = csv_items[i][key];
                  } else if (
                    !me.enableAutoMatchSearch_Location &&
                    me.verifyAndGetNewColumnName(me.current_longitude) == key
                  ) {
                    longitude = csv_items[i][key];
                  }
                  properties[key] = csv_items[i][key];
                  newColumnNames.push(key);
                }

                //check item contain latitude & longitude
                if (
                  !me.enableAutoMatchSearch_Location &&
                  latitude &&
                  longitude
                ) {
                  let latLng = L.latLng(
                    me.current_crs_option == GLOBAL.IMPORT.CRS_OPTIONS.HK1980
                      ? [
                          me.core.hk80ToXY(longitude, latitude)[1],
                          me.core.hk80ToXY(longitude, latitude)[0],
                        ]
                      : [latitude, longitude]
                  );

                  let tmpLayer = me.core.createTableMarkerOnly(
                    latLng,
                    properties
                  );

                  featureGroup.addLayer(tmpLayer);

                  newTableItems.push({
                    index:
                      me.current_option == IMPORT.OPTIONS.REPLACEALL
                        ? i + 1
                        : me.core.tableItems.length + i + 1,
                    leaflet_id: null,
                    geojson: tmpLayer.toGeoJSON(),
                    automatchedxy: true,
                  });
                } else {
                  let newTableItem = {
                    index:
                      me.current_option == IMPORT.OPTIONS.REPLACEALL
                        ? i + 1
                        : me.core.tableItems.length + i + 1,
                    leaflet_id: null,
                    geojson: null,
                    item: csv_items[i],
                  };
                  newTableItems.push(newTableItem);

                  if (
                    me.enableAutoMatchSearch_Location &&
                    !me.loadingDialog.abortAutoMatch
                  ) {
                    if (i == 0) {
                      me.loadingDialog.visible = true;
                      me.loadingDialog.tasks = csv_items.length;
                    }

                    if (
                      csv_items[i][me.current_batchLocationSearch].trim() == ""
                    ) {
                      me.loadingDialog.completedTasks += 1;
                      // console.log(me.loadingDialog.completedTasks, csv_items[i][me.current_batchLocationSearch])
                    } else {
                      // console.log(i , csv_items[i])
                      let url =
                        GLOBAL.MAP_API_URL.SEARCH_PLACES +
                        `?keyword=${encodeURIComponent(
                          csv_items[i][me.current_batchLocationSearch]
                        )}`;
                      me.core.customFetch({
                        url: url,
                        callback: function (res) {

                          // console.log(i, csv_items[i][me.current_batchLocationSearch])

                          // let items = res;

                          // console.log(res)

                          let exactMatchItems = res.filter((item) => {
                            let { eaddress, caddress, ename, cname } = item
                            let address = csv_items[i][me.current_batchLocationSearch]

                            eaddress = eaddress.replace(/[,.*+?^${}()|[\]\\ ]/g, "")
                            caddress = caddress.replace(/[,.*+?^${}()|[\]\\ ]/g, "")
                            address = address.replace(/[,.*+?^${}()|[\]\\ ]/g, "")
                            ename = ename.replace(/[,.*+?^${}()|[\]\\ ]/g, "")
                            cname = cname.replace(/[,.*+?^${}()|[\]\\ ]/g, "")

                            if (address.toUpperCase() == eaddress.toUpperCase()
                            || address.toUpperCase() == caddress.toUpperCase()
                            || address.toUpperCase() == ename.toUpperCase()
                            || address.toUpperCase() == cname.toUpperCase()) {
                              // return !tmpSkip;
                              return true
                            } else {
                              return false
                            }
                          })

                          let resultItems = []

                          // console.log("exactMatchItems", exactMatchItems)

                          if (exactMatchItems.length > 0) {
                            resultItems = exactMatchItems
                          } else {
                            resultItems = res.filter((item) => {
                              //skip facility
                              // return item.faciType == null ? true : false

                              for (let filterFacTypeSkipItem of FilterFacTypeSkip) {
                                if (
                                  item.faciType &&
                                  (item.faciType + "").trim().toUpperCase() ==
                                    (filterFacTypeSkipItem + "").trim().toUpperCase()
                                ) {
                                  return false
                                }
                              }

                              return true
                            })

                            // console.log("skip facility", resultItems)

                          }


                          // let skip = me.isSkipCSVItemsAutoMatch(resultItems);
                          let isVerifiedDistances = me.verifyDistances(resultItems)

                          if (isVerifiedDistances && resultItems && resultItems.length > 0) {
                            let coord = me.core.hk80ToXY(
                              resultItems[0]["easting"],
                              resultItems[0]["northing"]
                            );

                            let latLng = L.latLng([coord[1], coord[0]]);

                            let tmpLayer = me.core.createTableMarkerOnly(
                              latLng,
                              properties
                            );

                            newTableItem.geojson = tmpLayer.toGeoJSON();
                            newTableItem.item = null;
                            newTableItem["automatched"] = true;

                            me.core.reloadTableItemAndLayer(newTableItems[i]);
                            me.core.saveDataToLocalStorage();

                            me.loadingDialog.successMatchTasks += 1;
                          }

                          me.loadingDialog.completedTasks += 1;
                          // console.log(me.loadingDialog.completedTasks, csv_items[i][me.current_batchLocationSearch])

                          //show toast when finish + background run
                          if (
                            me.enableRunInBackground &&
                            !me.loadingDialog.visible &&
                            me.loadingDialog.tasks ==
                              me.loadingDialog.completedTasks
                          ) {
                            me.core.showNewSnackBar(
                              me.$t(
                                "common.loadingDialog.completedMatchMessage"
                              ) +
                                ": " +
                                me.loadingDialog.successMatchTasks
                              // +
                              // "/" +
                              // me.loadingDialog.tasks
                            );
                          }
                        },

                        error_callback: function (event) {

                          // console.log("error_callback", i, csv_items[i][me.current_batchLocationSearch])

                          me.loadingDialog.connectFailedTasks += 1;
                          me.loadingDialog.completedTasks += 1;
                        },
                      });
                    }
                  }
                }
              }

              //ready to check whether out of hk
              me.core.checkIntersects(featureGroup, () => {
                if (me.current_option == IMPORT.OPTIONS.REPLACEALL) {
                  me.core.deleteAllData(true);
                }

                for (let i = 0; i < newTableItems.length; i++) {
                  me.core.tableItems.push(newTableItems[i]);
                }

                for (let i = 0; i < newColumnNames.length; i++) {
                  me.core.addColumn(newColumnNames[i], i);
                }

                me.core.reloadTableItemsAndLayers();
                me.import_file_toast(true);
                // $cookies.set("showTableTourFromImport", "TRUE");
                // me.$refs["import_modal"].hide();
                me.import_modal = false;

                // if (!me.enableAutoMatchSearch_Location) {
                me.core.goToTableItemByIndex({
                  index: me.core.tableItems.length,
                });
                // }
              });
            }
          } catch (err) {
            process_import(null, false);
            console.log(err);
          }

          break;

        case this.formats.KML:
          try {
            this.$GA.import_kml();

            let featureGroup = this.verifyFile[this.formats.KML].featureGroup;

            this.core.checkIntersects(featureGroup, () => {
              if (this.current_option == IMPORT.OPTIONS.REPLACEALL) {
                this.core.deleteAllData(true);
              }
              this.process_import(featureGroup.getLayers(), true);
            });
          } catch (err) {
            this.process_import(null, false);
            console.log(err);
          }

          break;

        case this.formats.GML:
          try {
            this.$GA.import_gml();

            let featureGroup = this.verifyFile[this.formats.GML].featureGroup;

            this.core.checkIntersects(featureGroup, () => {
              if (this.current_option == IMPORT.OPTIONS.REPLACEALL) {
                this.core.deleteAllData(true);
              }
              this.process_import(featureGroup.getLayers(), true);
            });
          } catch (err) {
            this.process_import(null, false);
            console.log(err);
          }

          break;

        // case "GPX":
        //   reader.onload = function (e) {
        //     try {
        //       const jschardet = require("jschardet");
        //       const iconv = require("iconv-lite");

        //       const buffer = Buffer.from(e.target.result);
        //       const type = jschardet.detect(buffer);
        //       const res = iconv.decode(buffer, type.encoding);

        //       let featureGroup = me.createCRSLayer(
        //         omnivore.gpx.parse(res).toGeoJSON(),
        //         // me.current_crs_option,
        //         GLOBAL.IMPORT.CRS_OPTIONS.WGS1984,
        //         null,
        //         true
        //       );

        //       me.core.checkIntersects(featureGroup, () => {
        //         if (me.current_option == IMPORT.OPTIONS.REPLACEALL) {
        //           me.core.deleteAllData(true);
        //         }
        //         me.process_import(featureGroup.getLayers(), true);
        //       });
        //     } catch (err) {
        //       me.process_import(null, false);
        //       console.log(err);
        //     }
        //   };

        //   break;

        // case "WKT":
        //   reader.onload = function (e) {
        //     try {
        //       //					  		console.log(e.target.result)
        //       layers = omnivore.wkt.parse(e.target.result).getLayers();
        //       // console.log(layers);
        //       result = true;
        //     } catch (err) {
        //       result = false;
        //       console.log(err);
        //     }
        //     process_import(layers, result);
        //   };

        //   break;

        // case "TopoJSON":
        //   reader.onload = function (e) {
        //     try {
        //       //					  		console.log(e.target.result)
        //       layers = omnivore.topojson.parse(e.target.result).getLayers();
        //       // console.log(layers);
        //       result = true;
        //     } catch (err) {
        //       result = false;
        //       console.log(err);
        //     }
        //     process_import(layers, result);
        //   };

        //   break;

        // case "Shapefile":
        //   reader.onload = function (e) {
        //     try {
        //       //				  		console.log(this.file)
        //       shp(e.target.result).then(function (json) {
        //         //			  			console.log(json)
        //         layers = L.geoJson(json.features).getLayers();
        //         // console.log(layers);
        //         result = true;
        //         process_import(layers, result);
        //       });
        //     } catch (err) {
        //       result = false;
        //       // console.log(err);
        //       process_import(layers, result);
        //     }
        //   };

        //   break;
      }

      // //Shapefile not using reader
      // if (this.current_format != "Shapefile") {
      //   reader.readAsText(this.file);
      // } else {
      //shp support arraybuffer not text
      // reader.readAsArrayBuffer(this.file);
      // }
    },

    verifyDistances(items) {

      if (
        items
        // && items.length <= this.core.batchLocationSearchOnlyMatchResultItems
      ) {
        if (items.length > 1) {
          for (let i = 0; i < items.length; i++) {
            for (let j = 0; j < items.length; j++) {
              let a = items[i],
                b = items[j];
              if (a == b) {
                continue;
              } else {
                a = L.latLng(this.core.hk80ToXY(a["easting"], a["northing"]));

                b = L.latLng(this.core.hk80ToXY(b["easting"], b["northing"]));

                if (
                  a.distanceTo(b) >
                  this.core.batchLocationSearchLimitDistanceMeters
                ) {
                  return false
                }
              }
            }
          }
        }
        return true;
      }

      return false
    },

    convertCRS(collectLayers, from_crs, to_crs) {
      if (from_crs !== to_crs) {
        let layers = collectLayers.getLayers();
        for (let i = 0; i < layers.length; i++) {
          let layer = layers[i];
          //point
          if (typeof layer.getLatLngs === "function") {
            let latlngs = layer.getLatLngs();

            for (let j = 0; j < latlngs.length; j++) {
              if (Array.isArray(latlngs[j])) {
                for (let k = 0; k < latlngs[j].length; k++) {
                  let latlng = latlngs[j][k];
                  let coordinates = ol.proj.transform(
                    [latlng.lng, latlng.lat],
                    CRS_TO_EPSG[from_crs],
                    CRS_TO_EPSG[to_crs]
                  );

                  collectLayers.getLayers()[i].getLatLngs()[j][k] = {
                    lng: coordinates[0],
                    lat: coordinates[1],
                  };
                }
              } else {
                console.log("Not latLngs Array:", latlngs[j]);
              }
            }
          } else if (typeof layer.getLatLng === "function") {
            let coordinates = ol.proj.transform(
              layer.feature.geometry.coordinates,
              CRS_TO_EPSG[from_crs],
              CRS_TO_EPSG[to_crs]
            );

            // console.log(layer, layer.getLatLng(), coordinates);

            layer.getLatLng().lat = coordinates[1];
            layer.getLatLng().lng = coordinates[0];
          }
        }
      }

      return collectLayers;
    },

    process_import(layers, result) {
      // console.log("process_import", layers);
      let me = this;

      if (!layers || layers.length == 0) {
        me.import_file_toast(false);
        return;
      }

      try {
        if (layers.length > 0) {
          let tmpFeaturesGroup = [];

          for (let i = 0; i < layers.length; i++) {
            let layer = layers[i];

            for (let key in layer.feature.properties) {
              if (me.verifyAndGetNewColumnName(key) != key) {
                layer.feature.properties[me.verifyAndGetNewColumnName(key)] =
                  layer.feature.properties[key];
              }
              // if (
              //   me.verifyAndGetNewColumnName(layer.feature.properties[key]) !=
              //   layer.feature.properties[key]
              // ) {
              //   layer.feature.properties[
              //     me.verifyAndGetNewColumnName(layer.feature.properties[key])
              //   ] = layer.feature.properties[key];
              // }
            }

            //only add point data to table
            if (!me.existNonPointData(layer)) {
              me.core.addItemToTableData(layer, null);
              tmpFeaturesGroup.push(layer);
            } else {
              // me.core.map.removeLayer(layer);
            }
          }

          //only add point data to map
          if (tmpFeaturesGroup.length > 0) {
            me.core.addLayersToFeatureGroup(tmpFeaturesGroup);
          }

          result = true;
        } else {
          result = false;
        }
      } catch (err) {
        result = false;
      }

      this.verifyFile.file = null;
      if (result) {
        //show table & last page
        me.core.goToTableItemByIndex({ index: this.core.tableItems.length });

        me.$GA.import_submit_success();
        me.import_file_toast(true);
        // this.$refs["import_modal"].hide();
        me.import_modal = false;
        return true;
      } else {
        this.$GA.import_submit_fail();
        me.import_file_toast(false);
        return false;
      }
    },

    import_file_toast(valid) {
      if (valid) {
        this.core.showNewSnackBar(
          this.$t("common.import") +
            " " +
            this.current_format +
            " " +
            this.$t("common.successfully")
        );
      } else {
        this.core.showNewSnackBar(
          this.$t("common.import") +
            " " +
            this.current_format +
            " " +
            this.$t("common.failed")
        );
      }
    },
  },
};
</script>